// extracted by mini-css-extract-plugin
export default {"excelBtnOuterContainer":"collection_excelBtnOuterContainer__t6poB","excelTimeOuterContainer":"collection_excelTimeOuterContainer__3ZyNE"};